// ── Doorway facade: auth (browser side) ──────────────────────────────────────
//
// Slice 3. The browser's auth verbs: sign-in (OAuth + password), sign-out,
// and the auth-state listener. Callers pass the browser client they already
// hold (construction stays in lib/supabase.ts until the final slice).
// Client-safe on purpose — no server-only import.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BrowserClient = any

export async function signInWithOAuth(client: BrowserClient, options: { provider: string; options?: Record<string, unknown> }) {
  return client.auth.signInWithOAuth(options)
}

export async function signInWithPassword(client: BrowserClient, credentials: { email: string; password: string }) {
  return client.auth.signInWithPassword(credentials)
}

export async function signOutBrowser(client: BrowserClient) {
  return client.auth.signOut()
}

/** Auth-state listener; returns exactly what supabase-js returns (callers
 *  destructure `data.subscription` and unsubscribe on cleanup). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function onAuthStateChange(client: BrowserClient, callback: (event: string, session: any) => void) {
  return client.auth.onAuthStateChange(callback)
}
